import { ROUTES } from "@/constants/routeConstants";
import { useNavigate } from "react-router";

export const useAppNavigate = () => {
  const navigate = useNavigate();

  const goToHome = () => navigate("/");

  const goToLogin = () => navigate(ROUTES.LOGIN);

  const goToForgotPassword = () => navigate(ROUTES.FORGOT_PASSWORD);

  const goToChangePassword = () => navigate(ROUTES.CHANGE_PASSWORD);

  const goToContentGroup = () => navigate(ROUTES.CONTENT_GROUP);

  const goToContentGroupAdd = () => navigate(ROUTES.CONTENT_GROUP_ADD);

  const goToContentGroupDetail = (contentGroupGuid: string) =>
    navigate(`${ROUTES.CONTENT_GROUP_DETAIL}?Id=${contentGroupGuid}`);

  const goToSplitContentDetail = (contentGuid: string) => navigate(`${ROUTES.CONTENT_SPLIT_DETAIL}?Id=${contentGuid}`);

  const goToHospitalityMenu = () => navigate(`${ROUTES.HOSPITALITY_MENU}`);

  const goToHospitalityMenuAdd = () => navigate(`${ROUTES.HOSPITALITY_MENU_ADD}`);

  const goToHospitalityMenuDetail = (hospitalityMenuId: number) =>
    navigate(`${ROUTES.HOSPITALITY_MENU_DETAIL}?Id=${hospitalityMenuId}`);

  const goToFirm = () => navigate(ROUTES.FIRM);

  const goToFirmAdd = () => navigate(ROUTES.FIRM_ADD);

  const goToFirmDetail = (firmId: number) => navigate(`${ROUTES.FIRM_DETAIL}?Id=${firmId}`);

  const goToStore = () => navigate(ROUTES.STORE);

  const goToStoreAdd = () => navigate(ROUTES.STORE_ADD);

  const goToStoreDetail = (storeId: string) => navigate(`${ROUTES.STORE_DETAIL}?Id=${storeId}`);

  const goToUser = () => navigate(ROUTES.USER);

  const goToUserAdd = () => navigate(ROUTES.USER_ADD);

  const goToUserDetail = (userId: number) => navigate(`${ROUTES.USER_DETAIL}?Id=${userId}`);

  const goToMenu = () => navigate(ROUTES.MENU);

  const goToMenuAdd = () => navigate(ROUTES.MENU_ADD);

  const goToMenuDetail = (menuId: number) => navigate(`${ROUTES.MENU_DETAIL}?Id=${menuId}`);

  const goToMenuHeader = () => navigate(ROUTES.MENU_HEADER);

  const goToMenuHeaderAdd = () => navigate(ROUTES.MENU_HEADER_ADD);

  const goToMenuHeaderDetail = (menuHeaderId: number) => navigate(`${ROUTES.MENU_HEADER_DETAIL}?Id=${menuHeaderId}`);

  const goToAllergy = () => navigate(ROUTES.ALLERGY);

  const goToAllergyAdd = () => navigate(ROUTES.ALLERGY_ADD);

  const goToAllergyDetail = (allergyId: number) => navigate(`${ROUTES.ALLERGY_DETAIL}?Id=${allergyId}`);

  const goToRole = () => navigate(ROUTES.ROLE);

  const goToRoleAdd = () => navigate(ROUTES.ROLE_ADD);

  const goToRoleDetail = (roleId: number) => navigate(`${ROUTES.ROLE_DETAIL}?Id=${roleId}`);

  const goToTemplate = () => navigate(ROUTES.TEMPLATES);

  const goToTemplateAdd = () => navigate(ROUTES.TEMPLATE_ADD);

  const goToTemplateEditor = (guid: string) => (document.location.href = `${ROUTES.TEMPLATE_EDITOR}?Id=${guid}`);

  const goToTemplateStock = () => navigate(ROUTES.TEMPLATE_STOCK);

  const goToTemplateStockAdd = () => navigate(ROUTES.TEMPLATE_STOCK_ADD);

  const goToTemplateStockEditor = (guid: string) =>
    (document.location.href = `${ROUTES.TEMPLATE_STOCK_EDITOR}?Id=${guid}`);

  const goToContent = (showContentOptionsDialog?: boolean) =>
    navigate(`${ROUTES.CONTENT}?showContentOptionsDialog=${showContentOptionsDialog}`);

  const goToTag = () => navigate(ROUTES.TAG);

  const goToTagAdd = () => navigate(ROUTES.TAG_ADD);

  const goToTagDetail = (tagId: string) => navigate(`${ROUTES.TAG_DETAIL}?Id=${tagId}`);

  const goToScreenSize = () => navigate(ROUTES.SCREEN_SIZE);

  const goToScreenSizeAdd = () => navigate(ROUTES.SCREEN_SIZE_ADD);

  const goToScreenSizeDetail = (screenSizeId: string) => navigate(`${ROUTES.SCREEN_SIZE_DETAIL}?Id=${screenSizeId}`);

  const goToPlayer = () => navigate(ROUTES.PLAYER);

  const goToPlayerAdd = () => navigate(ROUTES.PLAYER_ADD);

  const goToPlayerDetail = (playerId: string) => navigate(`${ROUTES.PLAYER_DETAIL}?Id=${playerId}`);

  const goToChannel = () => navigate(ROUTES.CHANNEL);

  const goToChannelAdd = () => navigate(ROUTES.CHANNEL_ADD);

  const goToChannelDetail = (channelId: string) => navigate(`${ROUTES.CHANNEL_DETAIL}?Id=${channelId}`);

  const goToCampaign = () => navigate(ROUTES.CAMPAIGN);

  const goToCampaignAdd = () => navigate(ROUTES.CAMPAIGN_ADD);

  const goToCampaignDetail = (campaignId: string) => navigate(`${ROUTES.CAMPAIGN_DETAIL}?Id=${campaignId}`);

  const goToAreaType = () => navigate(ROUTES.AREA_TYPE);

  const goToAreaTypeAdd = () => navigate(ROUTES.AREA_TYPE_ADD);

  const goToAreaTypeDetail = (areaTypeId: string) => navigate(`${ROUTES.AREA_TYPE_DETAIL}?Id=${areaTypeId}`);

  const goToBlogPost = () => navigate(ROUTES.BLOG_POST);

  const goToBlogPostAdd = () => navigate(ROUTES.BLOG_POST_ADD);

  const goToBlogPostDetail = (blogPostId: string) => navigate(`${ROUTES.BLOG_POST_DETAIL}?Id=${blogPostId}`);

  const goToUserSubAdminAdd = (firmGuid: string) => navigate(`${ROUTES.USER_SUB_ADMIN_ADD}?firmGuid=${firmGuid}`);

  const goToUserSubAdminDetail = (userId: string, firmGuid: string) =>
    navigate(`${ROUTES.USER_SUB_ADMIN_DETAIL}?Id=${userId}&FirmGuid=${firmGuid}`);

  const goToContentGroupMemberCategory = () => navigate(ROUTES.CONTENT_GROUP_MEMBER_CATEGORY);

  const goToContentGroupMemberCategoryAdd = () => navigate(ROUTES.CONTENT_GROUP_MEMBER_CATEGORY_ADD);

  const goToContentGroupMemberCategoryDetail = (contentGroupMemberCategoryId: string) =>
    navigate(`${ROUTES.CONTENT_GROUP_MEMBER_CATEGORY_DETAIL}?Id=${contentGroupMemberCategoryId}`);

  return {
    goToHome,
    goToLogin,
    goToForgotPassword,
    goToChangePassword,
    goToContentGroup,
    goToContentGroupAdd,
    goToContentGroupDetail,
    goToSplitContentDetail,
    goToHospitalityMenu,
    goToHospitalityMenuAdd,
    goToHospitalityMenuDetail,
    goToFirm,
    goToFirmAdd,
    goToFirmDetail,
    goToStore,
    goToStoreAdd,
    goToStoreDetail,
    goToUser,
    goToUserAdd,
    goToUserDetail,
    goToMenu,
    goToMenuAdd,
    goToMenuDetail,
    goToMenuHeader,
    goToMenuHeaderAdd,
    goToMenuHeaderDetail,
    goToAllergy,
    goToAllergyDetail,
    goToAllergyAdd,
    goToRole,
    goToRoleAdd,
    goToRoleDetail,
    goToTemplate,
    goToTemplateAdd,
    goToTemplateEditor,
    goToTemplateStock,
    goToTemplateStockAdd,
    goToTemplateStockEditor,
    goToContent,
    goToTag,
    goToTagAdd,
    goToTagDetail,
    goToScreenSize,
    goToScreenSizeAdd,
    goToScreenSizeDetail,
    goToPlayer,
    goToPlayerAdd,
    goToPlayerDetail,
    goToChannel,
    goToChannelDetail,
    goToChannelAdd,
    goToCampaign,
    goToCampaignAdd,
    goToCampaignDetail,
    goToAreaType,
    goToAreaTypeAdd,
    goToAreaTypeDetail,
    goToBlogPost,
    goToBlogPostAdd,
    goToBlogPostDetail,
    goToUserSubAdminAdd,
    goToUserSubAdminDetail,
    goToContentGroupMemberCategory,
    goToContentGroupMemberCategoryAdd,
    goToContentGroupMemberCategoryDetail,
  };
};
